$(document).ready(function() {
    
$('.banner-lists').slick({
slidesToShow: 1,
infinite: true,
slidesToScroll: 1,
dots: true,
arrows: false,
focusOnSelect: true,
responsive: [
{
    breakpoint: 550,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
]
});

$(".reviews-lists").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    dots: false,
     responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  $(".brandBoxes").slick({
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 0,
     responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 5
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 420,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });

  $(".cateSlider .cateBoxes").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
     responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  $(".product-thumbnails-desk .thumbnails").slick({
    infinite: true,
    arrows: true,
    dots: false,
    vertical: true,
    verticalSwiping: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });

  $(".product-thumbnails-mob .thumbnails").slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });

  $(".products-slider .product-list").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      }
    ]
  });

    $(".product-recommendations .slick-grid").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      }
    ]
  });

});

// tabbed content
  // http://www.entheosweb.com/tutorials/css/tabs.asp
  $(".tab-container .tab_content").hide();
  // $(".tab-container .tab_content:first").show();
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });
  
  /* if in tab mode */
  $("ul.tabs li").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $(parent).find("#"+activeTab).fadeIn();
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(this).addClass("active");
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
    
    $('.product-list').slick('refresh');
  
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $(parent).find("#"+d_activeTab).fadeIn();
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

    $('.product-list').slick('refresh');
  });
  
  $(".coll-tags").removeClass('show-tags');
   $(".coll-tags .button").on('click',function(e){
     e.preventDefault();
	  $(".tags").slideToggle(300);
   });
  /* Extra class "tab_last"
     to add border to right side
     of last tab */
  $('ul.tabs li').last().addClass("tab_last");

  // mobile Tab
  $(document).off('click', '.select-label').on('click', '.select-label', function (e) {
    e.preventDefault();
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $('.dropdown').removeClass('active');
        $(this).parent().addClass('active');
      }
  });
  $(document).on('click','.dropdown-list li', function () {
      $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
      $(this).parents('.dropdown').removeClass('active');
      var variant_id = $(this).data('value');
      $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
  });